export default "__VITE_ASSET__7ewfpwqF__"